<script lang="ts" setup>
import { ref } from '#imports';
import { Empty } from 'ant-design-vue';
import { getSchoolList } from '~/api/common';
import type { IdNameOption } from '~/types/common';

defineOptions({
  inheritAttrs: false,
});

const loading = ref(false);
const options = ref<IdNameOption[]>([]);
const container = ref<HTMLDivElement>();
const popoverVisible = ref(false);
const model = defineModel('value', {
  type: String,
  required: true,
});
const props = defineProps({
  width: {
    type: String,
    required: true,
  },
  customClass: {
    type: String,
    default: ''
  },
});

function getContainer() {
  return container.value as HTMLDivElement;
}

function handleSelect(item: IdNameOption) {
  model.value = item.name;
}

function handleOpenPopover(visible: boolean) {
  if (visible) {
    handleSearch();
  }
}

const checkIsInputEmpty = (inputValue: string | undefined) =>
  !inputValue || inputValue?.trim() === '';

function handleSearch(event: Event | undefined = undefined) {
  const target = event?.target as HTMLInputElement;
  if (!target || checkIsInputEmpty(target.value)) {
    popoverVisible.value = false;
    options.value = [];
    return;
  }
  popoverVisible.value = true;
  loading.value = true;
  getSchoolList(target.value)
    .then((res) => {
      options.value = res;
    })
    .catch(() => {
      options.value = [];
    })
    .finally(() => {
      loading.value = false;
    });
}
</script>

<template>
  <div ref="container" :style="{ width }" :class="customClass">
    <a-popover
      v-model:open="popoverVisible"
      trigger="focus"
      placement="bottom"
      :arrow="false"
      :overlay-style="{ width }"
      :overlay-inner-style="{ padding: 0 }"
      :get-popup-container="getContainer"
      @open-change="handleOpenPopover"
    >
      <template #content>
        <div class="max-h-[300px] overflow-auto">
          <a-spin v-if="options.length > 0" :spinning="loading" :delay="500">
            <div class="p-1">
              <div
                v-for="item in options"
                :key="item.id"
                class="cursor-pointer rounded px-[12px] py-[6px] text-sm hover:bg-hover"
                @click="handleSelect(item)"
              >
                {{ item.name }}
              </div>
            </div>
          </a-spin>
          <a-empty
            v-else
            :image="Empty.PRESENTED_IMAGE_SIMPLE"
            description="请输入并搜索学校"
          />
        </div>
      </template>

      <a-input
        v-bind="$attrs"
        v-model:value.trim="model"
        allow-clear
        autocomplete="off"
        :maxlength="100"
        @change="handleSearch"
      />
    </a-popover>
  </div>
</template>

<style scoped></style>
